import React from "react";
import "./Herocontentl.css";
import hero from "../../assets/images/heroimg.png";
import navdot from "../../assets/images/hero-nav.svg";
import { useNavigate } from "react-router-dom";

function Herocontentl() {
  const navigate = useNavigate();
  const goToAbout = () => {
    navigate('/councellors');
  };
  return (
    <div className="hero-container">
      <div className="hero-sec-content">
        <div className="hero-img">
          <img src={hero} alt="riso app img" />
        </div>
        
        <div className="hero-text-container">
          <div className="hero-text">
             Empower your career journey with AI + expert guidance
          </div>
          <div className="hero-text-desc">
             Discover your ideal career and education path with the perfect blend of experienced counsellors and intelligent AI support—personalized just for you.
          </div>
          <button className="talk-expert-btn" onClick={goToAbout}>Talk to a carrer expert</button>
        </div>
      </div>
    </div>
  );
}

export default Herocontentl;
